import { Component, OnInit } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { userActions } from '@src/store/reducers/userReducer';

import $ from 'jquery';
import { IDomain } from '@src/interfaces/domain.interfaces';

@Component({
    selector: 'domain-manager',
    template: require('./domain-manager.component.html'),
    styles: [require('./domain-manager.component.scss')]
})
export class DomainManagerComponent implements OnInit {
    public hasItems = false;
    public domain: IDomain;
    public domains: IDomain[];
    public selectedDomain: any;

    private unSubscribe: any;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService) {
    }

    public ngOnInit() {
        this.unSubscribe = this.store.subscribe(() => {
            const domainsState = this.store.getState().user.domains;
            if (domainsState) {
                this.domains = domainsState;
                this.hasItems = this.domains.length === 0;
                if (this.domains.length > 0) {
                    this.domain = this.domains[0];
                }
                this.unSubscribe();
            }
        });
        this.store.dispatch({ type: userActions.GET_DOMAINS });
    }

    public addDomain() {
        this.domain = {
            authenticationType: 1,
            baseDN: '',
            domainHost: '',
            domainPort: 389,
            anonymousAuth: false,
            emailAttribute: 'mail',
            firstNameAttribute: 'givenName',
            groupsMapping: { domainId: 0, roles: [], projectGroups: [] },
            id: 0,
            ignoreUnmappedObjects: false,
            isNew: true,
            lastNameAttribute: 'sn',
            logonAttribute: 'sAMAccountName',
            manualSettings: false,
            name: 'New Domain',
            password: '',
            useSSL: false,
            userDN: ''
        };

        this.domains = [this.domain, ...this.domains];
        this.hasItems = true;
        this.selectedDomain = this.domains[0];
        this.unSubscribe = this.store.subscribe(() => {
            const domainState = this.store.getState().user.domain;
            if (domainState) {
                this.selectedDomain.id = domainState.id;
                this.unSubscribe();
            }
        });
    }

    public deleteDomain() {
        this.dialogManagerService.showConfirmationDialog(
            {
                title: 'Delete Domain',
                action: 'delete',
                objectType: 'domain',
                item: this.selectedDomain.name
            },
            () => {
                if (this.domain.isNew) {
                    this.domains = this.domains.filter(x => x !== this.selectedDomain);
                    this.domain = this.domains.length > 0 ? this.domains[0] : null;
                    this.selectedDomain = this.domain;
                    return;
                }
                this.unSubscribe = this.store.subscribe(() => {
                    const domainsState = this.store.getState().user.domains;
                    if (domainsState && this.domains.length > domainsState.length) {
                        this.domains = domainsState;
                        this.domain = this.domains[0];
                        this.selectedDomain = this.domain;
                        this.unSubscribe();
                        setTimeout(() => $('.domains-container li.spacer:nth-child(1)').click(), 1);
                    }
                });
                this.store.dispatch({
                    type: userActions.DELETE_DOMAIN,
                    payload: { domainId: this.selectedDomain.id }
                });
            }
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-manager.component.ts